import {arrayOf, bool, func, number, shape, string} from 'prop-types';
import { Fragment } from 'react';
import CoverageSection from './CoverageSection';
import AddItemBox from '../../shared/AddItemBox';
import {coverageObj} from './OrvPage';
import GeneralOrvSection from './GeneralOrvSection';
import {useTranslation} from "react-i18next";

const InsuranceBlock = ({
  indexInsurance,
  insurance,
  meta,
  insuranceCompanies,
  setInsurance,
  setCoverage,
  addCoverage,
  removeCoverage,
  errors,
  canEditOrv,
}) => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <GeneralOrvSection
        {...{
          ...insurance,
          insuranceCompanies,
          indexInsurance,
          setInsurance,
          errors,
          canEditOrv,
        }}
      />
      {insurance?.coverages?.map((coverage, indexCoverage) => {
        return (
          <CoverageSection
            key={indexCoverage}
            setCoverage={(e) => setCoverage(e, indexInsurance, indexCoverage)}
            removeCoverage={() => removeCoverage(indexInsurance, indexCoverage)}
            indexCoverage={indexCoverage}
            removable={insurance.coverages.length > 1}
            errors={errors}
            indexInsurance={indexInsurance}
            meta={meta}
            canEditOrv={canEditOrv}
            {...coverage}
          />
        );
      })}
      {canEditOrv && (
        <AddItemBox
          title={t("Dekking toevoegen")}
          onClick={() => addCoverage(indexInsurance)}
        />
      )}
    </Fragment>
  );
};

InsuranceBlock.propTypes = {
  indexInsurance: number.isRequired,
  insurance: shape({
    insurance_company: number,
    policy_number: string,
    start_date: string,
    coverages: arrayOf(shape(coverageObj)),
    premium: shape({
      amount: number,
      period: string,
      duration_in_months: number,
    }),
  }),
  insuranceCompanies: arrayOf(shape({ value: number, label: string })),
  setInsurance: func.isRequired,
  setCoverage: func,
  addCoverage: func,
  removeCoverage: func,
  errors: shape({}),
  canEditOrv: bool,
};

InsuranceBlock.defaultProps = {
  insurance: {
    insurance_company: null,
    policy_number: '',
    start_date: '',
    premium: { amount: null, period: '', duration_in_months: null },
    coverages: [coverageObj],
  },
  insuranceCompanies: [],
  setCoverage: () => {},
  addCoverage: () => {},
  removeCoverage: () => {},
  errors: {},
  canEditOrv: false,
};

export default InsuranceBlock;
